import { Button, Checkbox, Col, Form, Input, Row, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import ConfirmationBox from "../../../../../../components/common/ConfirmationBox";
import MultiSelect from "../../../../../../components/common/MultiSelect";
import UsefulMessage from "../../../../../../components/common/UsefulMessage";
import { names } from "../../../../../../data/people";

function Email({ workOrderNumber, setIsConfirmationBoxOpen }) {
  return (
    <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
      <h2>Notify Owner for Work Order #{workOrderNumber}</h2>
      <Form layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item label="Recipients" required>
              <MultiSelect options={names} placeholder="Select" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Send BCC to">
              <MultiSelect options={names} placeholder="Select" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item>
              <UsefulMessage message="Requesting Estimates has been moved to the Estimates feature." />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Email subject" required>
              <Input placeholder="Subject here" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Email body">
              <TextArea rows={10} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Attachments">
              <Space direction="vertical">
                <Checkbox>Portal_Upload_Screensho....png(232 KB)</Checkbox>
                <Checkbox>Portal_Upload_Screensho....png(232 KB)</Checkbox>
                <Checkbox>Portal_Upload_Screensho....png(232 KB)</Checkbox>
              </Space>
              </Form.Item>
          </Col>
        </Row>
        <div className="action-buttons">
          <Button type="primary">Save</Button>
          <button
            className="cancel-btn"
            onClick={() => setIsConfirmationBoxOpen(false)}
          >
            Cancel
          </button>
        </div>
      </Form>
    </ConfirmationBox>
  );
}

export default Email;
